'use client';

import { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';

import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAnalytics } from '@/hooks/analytics';
import genericMessages from '@/messages/messages';

export default function TermsLink({ children }: PropsWithChildren) {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();

	const message = children ?? formatMessage(genericMessages.terms);

	return (
		<a
			href="/terms"
			target="_blank"
			onClick={() =>
				logEvent({
					eventName: 'Login Form : Terms : Clicked',
					eventProps: {
						mode: authPrompt,
					},
				})
			}
		>
			{message}
		</a>
	);
}
